import React from 'react';

import EmailDeliveryFailuresPage from '~/components/System/EmailDeliveryFailures/EmailDeliveryFailuresPage';

import { LE_BUSINESS_TRAVELLER } from '~/consts/businessTraveller';

export default function LebtEmailDeliveryFailuresPage() {
  return <EmailDeliveryFailuresPage brand={LE_BUSINESS_TRAVELLER} embedded />;
}
